import { Box } from "@mui/material";

import {
  AdditionalInterest,
  HomeDetails,
  PersonalDetailsAndAdditionalInsured,
  PolicyTerm,
  PropertyAddress,
} from "./Sections";
import { ViewOnlyNotice } from "../ViewOnlyNotice";
import { useInsuredTab } from "./useInsuredTab";

export type { InsuredTabFormValues } from "@redux/slices/endorsement";

/** Insured Info endorsement step — renders all insured-detail sections. */
export const InsuredInfoStep = () => {
  const { viewOnly } = useInsuredTab();

  return (
    <Box display="flex" flexDirection="column">
      {viewOnly && <ViewOnlyNotice />}
      <PolicyTerm viewOnly={viewOnly} />
      <PropertyAddress viewOnly={viewOnly} />
      <HomeDetails viewOnly={viewOnly} />
      <PersonalDetailsAndAdditionalInsured viewOnly={viewOnly} />
      <AdditionalInterest viewOnly={viewOnly} />
    </Box>
  );
};
